$(document).ready(function() {

	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm('monthly');
	}

	// count up statistics from zero
	$('.vpne-statistics-group').each(function(index, group) {
		var statistics = $('.vpne-statistic', group);
		$(statistics).each(function(index, statistic) {
			var target = $('.vpne-statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number') * 1;
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var options = {
				startVal: 0,
				duration: 3,
				useGrouping: true,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	});

	// solutions cards
	// $('.vpne-solutions-cards-group').each(function(index, group) {
	// 	var slider = $(group).flickity({
	// 		arrowShape: 'm1.1 47.2c-1.5 1.5-1.5 4 0 5.5l24.8 24.8c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-22-22 22-22c1.5-1.5 1.5-4 0-5.5s-4-1.5-5.5 0zm98.9-1.1h-96.1v7.8h96.1z',
	// 		cellAlign: 'left',
	// 		percentPosition: true,
	// 		prevNextButtons: true,
	// 		wrapAround: true,
	// 	})
	// });

	// vpne cares gallery slider in a box
	$('.vpne-cares-box-gallery-slider').each(function(index, group) {
		var count = $('.vpne-cares-box-gallery-item', group).length;
		console.log('count:', count);
		if (count > 1) {
			var slider = $(group).flickity({
				adaptiveHeight: true,
				arrowShape: 'm1.1 47.2c-1.5 1.5-1.5 4 0 5.5l24.8 24.8c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-22-22 22-22c1.5-1.5 1.5-4 0-5.5s-4-1.5-5.5 0zm98.9-1.1h-96.1v7.8h96.1z',
				cellAlign: 'left',
				prevNextButtons: true,
				wrapAround: true,
			});
		}
	});

});
